const TPDataModel = () => import('@/views/pages/dataResource/dataModel/TPModel/index.vue');
const APDataModel = () => import('@/views/pages/dataResource/dataModel/APModel/index.vue');
const DataModelView = () => import('@/views/pages/dataResource/dataModel/dataModelView/index.vue');
const DataModelDetail = () => import('@/views/pages/dataResource/dataModel/ModelDetail/index.vue');
const DataResort = () => import('@/views/pages/dataResource/dataResort/index.vue');

// const dataResourceCatalog = () => import('@/views/pages/dataResource/catalog/dashboard.vue');
const dataResourceCatalog = () => import('@/views/pages/dataResource/catalog/views/index.vue');
const dataResourceCatalogV2 = () => import('@/views/pages/dataResource/catalogV2/index.vue');
// const dataResourceView = () => import('@/views/pages/dataResource/catalog/views/index.vue');

const dataResourceCatalogEntityDetail = () => import('@/views/pages/dataResource/catalog/views/entityDetail.vue');

const businessObject = () => import('@/views/pages/dataResource/dataResourceCatalog/businessObject/index.vue');

/* dataset cost */
const datasetCost = () => import('@/views/pages/home/datasetCost/index.vue');

const DataResource = [
  {
    path: 'tPDataModel',
    component: TPDataModel,
    name: '/tPDataModel',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Transactional Data Model',
      mid: '3a8c-e194',
    },
  },
  {
    path: 'aPDataModel',
    component: APDataModel,
    name: '/aPDataModel',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Analytical Data Model',
      mid: '1f7b-6d09',
    },
  },
  {
    path: 'dataModelDetail',
    component: DataModelDetail,
    name: '/dataModelDetail',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Model Detail',
      mid: 'c5e2-9a84',
    },
  },
  {
    path: 'dataModelView',
    component: DataModelView,
    name: '/dataModelView',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Model View',
      mid: '7b0d-4f61',
    },
  },
  {
    path: 'dataResort',
    component: DataResort,
    name: '/dataResort',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Resort',
      mid: '2e96-8c3a',
    },
  },
  {
    path: 'dataResourceCatalog',
    component: dataResourceCatalog,
    name: 'dataResourceCatalog',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Resource Catalog',
      mid: 'd4f1-5b07',
    },
  },
  {
    path: 'dataResourceCatalog',
    component: dataResourceCatalogV2,
    name: 'dataResourceCatalog',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Resource Catalog',
      mid: 'd4f1-5b07',
    },
  },
  {
    path: 'dataResourceCatalogEntityDetail',
    component: dataResourceCatalogEntityDetail,
    name: 'dataResourceCatalogEntityDetail',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Resource Catalog Entity Detail',
      mid: 'a83c-9e26',
    },
  },
  {
    path: 'businessObject',
    component: businessObject,
    name: 'businessObject',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Business Object Browser',
      mid: '6e09-f4d5',
    },
  },

  // {
  //   path: 'dataResourceView',
  //   component: dataResourceView,
  //   name: 'dataResourceView',
  //   meta: {
  //     ownType: 'Metadata',
  //     lableTitle: 'Data Resource Catalog',
  //   },
  // },

  {
    path: 'datasetCost',
    component: datasetCost,
    name: 'datasetCost',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Dataset Cost',
      mid: 'b2a7-3c80',
    },
  },
];
export default DataResource;
